import React, { useMemo } from 'react';
import type { TextBlock } from '../../store/chatStore';
import { MessageFileItem } from './MessageFileItem';

interface FileTextContentProps {
  content: TextBlock;
}

interface ExtractedFileData {
  filename: string;
  body: string;
  mimeType: string;
}

const extractFileData = (
  text: string,
  fallback: TextBlock['metadata'],
): ExtractedFileData => {
  const match = text.match(
    /<file-content[^>]*filename="([^"]+)"[^>]*>([\s\S]*?)<\/file-content>/i,
  );
  if (match) {
    const [, filename, body] = match;
    return {
      filename,
      body,
      mimeType: fallback?.fileType || 'text/plain',
    };
  }

  // Fallback: treat entire text as file body
  const filename = fallback?.filename || 'file.txt';
  return {
    filename,
    body: text,
    mimeType: fallback?.fileType || 'text/plain',
  };
};

export const FileTextContent: React.FC<FileTextContentProps> = ({
  content,
}) => {
  const fileData = useMemo(
    () => extractFileData(content.text, content.metadata),
    [content],
  );

  const handleDownload = () => {
    const blob = new Blob([fileData.body], {
      type: fileData.mimeType || 'text/plain',
    });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  return (
    <MessageFileItem
      fileName={fileData.filename}
      mimeType={fileData.mimeType}
      sizeBytes={content.metadata?.fileSize}
      onDownload={handleDownload}
    />
  );
};
